import type { ToneOverlay } from "../index.js";

// The dark voice: gallows humour for people who cope by joking. Opt-in (supporter perk);
// the serious "human" voice is always the default. Multi-variant lines rotate every other
// hour (TONE_ROTATE_MS), so the deadpan doom stays fresh. Each variant must keep the same
// {placeholders} as the base string (enforced by tone-guardrail.test.ts).
export const overlay: ToneOverlay = {
  "alert.toast.new": [
    "{hazard} nearby. Today's getting interesting.",
    "{hazard} nearby. Plot twist.",
    "{hazard} reported. The universe says hi.",
    "{hazard} nearby. Of course it is.",
    "{hazard} spotted. Adventure, unwillingly.",
    "{hazard} nearby. Cool cool cool. Not cool.",
  ],
  "alert.toast.escalation": [
    "{hazard} just leveled up. Lovely.",
    "{hazard} got worse. It does that.",
    "{hazard} is escalating. Bold of it.",
    "{hazard} turned it up to eleven.",
    "{hazard} read the room and chose chaos.",
  ],
  "alert.toast.inPath": [
    "{hazard} picked you, apparently. Move.",
    "{hazard} headed your way. Flattering. Run.",
    "{hazard} has chosen violence. Go.",
    "{hazard} coming for you specifically. Move it.",
    "{hazard} wants a word. Decline. Leave.",
  ],
  "alert.toast.allClear": [
    "Still alive near {place}. Nice work.",
    "{place} didn't get you. This time.",
    "Survived {place}. Put it on the résumé.",
    "All clear near {place}. Lucky you.",
    "{place} blinked first. Well done.",
  ],
  "alert.toast.tap": [
    "Tap for the plan to keep breathing.",
    "Tap for instructions on not dying.",
    "Tap. Staying alive is on the next screen.",
  ],
  "alert.takeover.title": [
    "{hazard} — this is your main-character moment. Go.",
    "{hazard} — the part of the movie where you run.",
    "{hazard} — act now, narrate later.",
    "{hazard} — plot demands you leave. Now.",
  ],
  "alert.takeover.details": "The grim details",
  "alert.takeover.dismiss": "Survived, dismiss",
  "now.status.allClear": [
    "Still here. Good.",
    "Not dead yet.",
    "Statistically fine.",
    "The void is quiet.",
    "Boringly alive.",
    "No notes from the apocalypse.",
    "Cosmically uneventful.",
    "Unkilled, so far.",
  ],
  "now.status.stayAware": [
    "Stay frosty.",
    "Trust nothing.",
    "Keep one eye open.",
    "This is the calm part.",
    "Don't get comfortable.",
    "Stay suspicious.",
  ],
  "now.status.sub.allClear": [
    "Nothing trying to kill you in range. Rare.",
    "No hazards nearby. Suspicious, but we'll take it.",
    "The radius is clean. For now.",
    "Nothing on the scope. Savour it.",
    "All quiet on the doom front.",
    "Nothing incoming. The universe is distracted.",
  ],
  "now.activity.empty": [
    "Suspiciously quiet out there.",
    "Nothing. Almost rude.",
    "The feed is as empty as the void.",
    "Crickets. Ominous crickets.",
    "No news. We'll pretend that's good.",
    "Dead silent. Poor choice of words.",
  ],
  "onboarding.promise.tagline": "Neighbours keeping neighbours above ground.",
  "onboarding.promise.continue": "Let's survive this",
  "onboarding.home.browse": "Just window-shopping the apocalypse",
  "you.voice.intro": "Choose your flavour of bad news.",
};
